import React, { useState, useRef, useEffect } from "react";
import { FaChevronDown, FaSearch, FaCheck } from "react-icons/fa";

const UserCustomDropdown = ({
  options = [],
  value,
  onChange,
  placeholder = "Select option",
  searchable = true,
  iconMap = {},
}) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
        setSearch("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedOption = options.find((o) => o.value === value);

  const filteredOptions = options.filter((o) =>
    o.label.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div ref={wrapperRef} className={`relative w-full ${open ? 'z-[9999]' : ''}`}>
      {/* Trigger */}
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-4 py-3 bg-[rgba(255,255,255,0.05)] border border-glass-border rounded-xl focus:outline-none focus:ring-2 focus:ring-primary-pink hover:bg-[rgba(255,255,255,0.08)] transition-colors"
      >
        <div className="flex items-center gap-2 text-text-primary truncate">
          {selectedOption && iconMap[selectedOption.value]}
          <span className={selectedOption ? "truncate" : "text-text-muted truncate"}>
            {selectedOption ? selectedOption.label : placeholder}
          </span>
        </div>
        <FaChevronDown
          className={`text-gray-500 transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>

      {/* Dropdown - Now uses absolute positioning */}
      {open && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-[rgba(255,255,255,0.95)] dark:bg-slate-900 border border-gray-200 dark:border-glass-border rounded-xl shadow-glass overflow-hidden z-50">
          {searchable && (
            <div className="p-3 border-b border-glass-border">
              <div className="relative">
                <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-text-muted text-sm" />
                <input
                  type="text"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Search..."
                  className="w-full pl-9 pr-3 py-2 text-sm bg-transparent border border-gray-200 dark:border-glass-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-pink text-text-primary dark:text-white placeholder:text-text-muted"
                  autoFocus
                />
              </div>
            </div>
          )}

          <div className="max-h-60 overflow-y-auto custom-scrollbar">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option) => (
                <button
                  key={option.value}
                  type="button"
                  onClick={() => {
                    onChange(option.value);
                    setOpen(false);
                    setSearch("");
                  }}
                  className={`w-full flex items-center justify-between px-4 py-3 text-sm hover:bg-gray-100 dark:hover:bg-[rgba(255,255,255,0.05)] transition-colors ${
                    value === option.value ? "bg-rose-50 dark:bg-[rgba(255,46,136,0.1)]" : ""
                  }`}
                >
                  <div className="flex items-center gap-2 text-text-primary">
                    {iconMap[option.value]}
                    <span>{option.label}</span>
                  </div>
                  {value === option.value && (
                    <FaCheck className="text-primary-pink text-sm" />
                  )}
                </button>
              ))
            ) : (
              <div className="px-4 py-6 text-center text-sm text-text-muted">
                No results found
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default UserCustomDropdown;